@if (context && isAdmin) {
    @if (inline) {
        <button
            type="button"
            class="audit-inline-button"
            mat-icon-button
            matTooltip="Voir l'historique"
            (click)="openHistory()">
            <mat-icon svgIcon="heroicons_outline:clock"></mat-icon>
        </button>
    } @else {
        <button
            type="button"
            class="audit-floating-button"
            mat-fab
            color="primary"
            matTooltip="Voir l'historique"
            (click)="openHistory()">
            <mat-icon svgIcon="heroicons_outline:clock"></mat-icon>
        </button>
    }
}
